/**
 * Determine the branding (name + logo) that should be shown for a job.
 * If the job is linked to a sub-label with an active, filled label, that
 * label's branding takes precedence over the main company branding.
 */
export interface JobBrandingInput {
  sub_label_id?: string | null;
  sub_label?: {
    id?: string;
    name?: string | null;
    logo_url?: string | null;
    is_active?: boolean | null;
  } | null;
  company?: {
    id?: string;
    name?: string | null;
    logo_url?: string | null;
  } | null;
}

export interface JobBranding {
  name: string;
  logoUrl: string | null;
  isSubLabel: boolean;
}

export function getJobBranding(job: JobBrandingInput | null | undefined): JobBranding {
  const sub = job?.sub_label;
  if (sub && sub.is_active !== false && (sub.name || sub.logo_url)) {
    return {
      name: sub.name || job?.company?.name || "",
      logoUrl: sub.logo_url || job?.company?.logo_url || null,
      isSubLabel: true,
    };
  }
  return {
    name: job?.company?.name || "",
    logoUrl: job?.company?.logo_url || null,
    isSubLabel: false,
  };
}
